import React, { useContext, useEffect, useState } from 'react'
import { HeaderMenu } from '../../components/HeaderMenu.comp'
import GaugeOneHidric from '../../components/charts/GaugeOneHidric.chart'
import { GetListMEdidores } from '../../API/OUR_Lecturas/GetListMEdidores.api';
import LoginContext from '../../context/login_context/LoginContext';
import OUR_GaugeOneTest from '../../components/charts/OUR_GaugeOneTest.chart';
import { OUR_IndicadorAmoniaco } from '../../components/charts/OUR_IndicadorAmoniaco';
import { LineFour } from '../../components/charts/LineFour.chart';

export const Amoniaco = () => {

    const {LoginState,SetLogin,CloseLogin,GetLoginSession} = useContext(LoginContext);

    const [ListMedidores_, setListMedidores_] = useState([]);
    const [ShowmetheModal_, setShowmetheModal_] = useState(false);
    const [ShowmetheModal_ACUM, setShowmetheModal_ACUM] = useState(false);
    const [MedidorToModal, setMedidorToModal] = useState('');

    const GetListMedidores = async () => {
        let list_ = await GetListMEdidores({empresa:LoginState.planta})
        let listFil = await list_.filter(fl => fl.ELEMENTO === "AMONIACO")
        console.log(listFil)
        // let listFil_ = await list_["ai"].filter(fl => fl.ELEMENTO === ""NIVEL"")
        // let concatenar_ = await listFil.concat(listFil_)
        // console.log(list_);
        setListMedidores_(listFil);
        return (<div>menu flotante</div>)
    }

    const ShowModalData = async (data) => {
        // console.log(data);
        setMedidorToModal(data);
        setShowmetheModal_(true)
    }

    useEffect(() => {
      GetListMedidores()
    
      return () => {
        GetListMedidores()
      }
    }, [])
    
    return (<>
        <HeaderMenu Pag_Sel={'/amoniaco'} />  
        
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-12'>
                    <h1>Sensores NH₃</h1>
                </div>
                <div className='col-12'>
                    <div className='row'>
                    {
                        ListMedidores_.map((med, index) => 
                            <div className='col-12 col-md-4 col-lg-3 col-xl-2'>
                                <div className='row p-2'>
                                    <div className='col-12 border-nh3'>
                                        <OUR_GaugeOneTest key={index} DATA={med} ShowModalData={ShowModalData} />
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    </div>
                </div>
            </div>
        </div>
        {
            ShowmetheModal_?
                <div className='modal_chdata'>
                    <button
                        onClick={()=>setShowmetheModal_(false)}
                        className='btn btn-danger btn-sm'
                        style={{position: 'absolute', top: '10px', left: '10px'}}
                        >Cerrar</button>
                    <div className='bg-info w-100 text-center'>
                        <LineFour DATA={MedidorToModal} />
                        {/* <LineFive DATA={MedidorToModal} /> */}
                    </div>
                </div>
            :null
        }
    </>
    )
}
